import { useQuery } from '@tanstack/react-query';
import { contentApi } from '../services/api';

export interface ContentCard {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  year: number;
  rating?: number;
  genres: string[];
  imageUrl: string;
}

export interface PersonDetails {
  id: string;
  name: string;
  birthYear?: number;
  deathYear?: number;
  primaryProfession: string[];
  knownForTitles: ContentCard[];
  biography?: string;
  imageUrl?: string;
  filmography?: ContentCard[];
}

export const usePersonDetails = (id: string) => {
  return useQuery({
    queryKey: ['person', id],
    queryFn: async () => {
      const response = await contentApi.getPersonDetails(id);
      // The API now returns the full PersonDetails structure
      return response as PersonDetails;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};